import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "divide-y divide-gray-200" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "relative flex items-start mb-4" }
const _hoisted_6 = { class: "flex items-center h-5" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = { class: "relative flex items-start mb-4" }
const _hoisted_9 = { class: "flex items-center h-5" }
const _hoisted_10 = ["onUpdate:modelValue", "id", "name", "checked"]
const _hoisted_11 = { class: "ml-3 text-sm" }
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "text-clay-800 cursor-pointer" }
const _hoisted_14 = { class: "px-4 py-3 sm:px-6 md:w-1/4" }

import {computed, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetSubscriptionPreferences, GetSubscriptionPreferencesResponse
} from "@/dtos";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionPreferences',
  setup(__props) {

onMounted(async () => {
    await getSubscriptionPreferences();
});
const preferences = ref({});

const isFetching = ref(true);
const getSubscriptionPreferences = async () => {
    await client.get<GetSubscriptionPreferencesResponse>(new GetSubscriptionPreferences())
        .then(response => {
            preferences.value = response.preferences;
            isFetching.value = false;
        });
}

const topics = computed(() => {
    let transformedTopics: any = {};
    
    preferences.value.customer.topics.forEach((t: any) => {
        transformedTopics[`topic_${t.id}`] = t.subscribed;
    });
    return transformedTopics;
});

const updateSuccessful: Ref<Boolean> = ref(false);
const responseStatus = ref(null);

const isSubmitting = ref(false);
const updateSubscriptionPreferences = async () => {
    isSubmitting.value = true;
    updateSuccessful.value = false;
    
    analytics.identify({
        cio_subscription_preferences: {
            topics: topics.value
        },
        unsubscribed: preferences.value.customer.unsubscribed
    });

    updateSuccessful.value = true;
    responseStatus.value = null;
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
    isSubmitting.value = false;
    
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
        (isFetching.value)
          ? (_openBlock(), _createBlock(SkeletonCard, {
              key: 0,
              class: "mt-4",
              "card-style": "long",
              "num-of-cards": 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((preferences.value.customer.unsubscribed) = $event)),
                      id: "global",
                      name: "global",
                      checked: preferences.value.customer.unsubscribed,
                      "aria-describedby": "",
                      class: "w-4 h-4 text-powder-600 border-2 border-gray-500 rounded cursor-pointer focus:ring-powder-500",
                      type: "checkbox"
                    }, null, 8, _hoisted_7), [
                      [_vModelCheckbox, preferences.value.customer.unsubscribed]
                    ])
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ml-3 text-sm" }, [
                    _createElementVNode("label", {
                      for: "global",
                      class: "font-medium text-gray-700 cursor-pointer"
                    }, "Opt out of all communications"),
                    _createElementVNode("div", { class: "text-clay-800 cursor-pointer" }, "Fully unsubscribe from all topics, retaining only essential notifications.")
                  ], -1))
                ])
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "my-4" }, null, -1)),
              _createElementVNode("div", {
                class: _normalizeClass(["mt-4", preferences.value.customer.unsubscribed ? 'pointer-events-none opacity-30 cursor-not-allowed' : ''])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preferences.value.customer.topics, (topic) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((topic.subscribed) = $event),
                        id: topic.name,
                        name: topic.name,
                        checked: topic.subscribed,
                        "aria-describedby": "",
                        class: "w-4 h-4 text-powder-600 border-2 border-gray-500 rounded cursor-pointer focus:ring-powder-500",
                        type: "checkbox"
                      }, null, 8, _hoisted_10), [
                        [_vModelCheckbox, topic.subscribed]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", {
                        for: topic.name,
                        class: "font-medium text-gray-700 cursor-pointer"
                      }, _toDisplayString(topic.name), 9, _hoisted_12),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(topic.description), 1)
                    ])
                  ]))
                }), 256))
              ], 2),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(SaButton, {
                  onClick: _withModifiers(updateSubscriptionPreferences, ["prevent"]),
                  loading: isSubmitting.value,
                  variant: "primary"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Save Preferences ")
                  ])),
                  _: 1
                }, 8, ["loading"])
              ])
            ]))
      ])
    ]),
    _createVNode(NotificationSuccess, {
      show: updateSuccessful.value,
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})